import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormikFieldHelperText from '~components/field-helper-text/formik-field-helper-text';
import SelectPopper from './select-popper';

function FormikSelect(props) {
  const { fieldConfig, FieldHelperTextProps, ...others } = props;
  const [field, meta, helpers] = useField(fieldConfig);
  return (
    <>
      <SelectPopper
        {...field}
        onChange={(e) => {
          helpers.setTouched(true);
          helpers.setValue(e.target.value);
        }}
        {...others}
        InputProps={{ error: meta.touched && !!meta.error, fullWidth: true, ...others.InputProps }}
      />
      <FormikFieldHelperText {...FieldHelperTextProps} meta={meta} />
    </>
  );
}

FormikSelect.propTypes = {
  fieldConfig: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  FieldHelperTextProps: PropTypes.object,
  // all other props will be applied to InputBase component
};

FormikSelect.defaultProps = {
  FieldHelperTextProps: undefined,
};

export default FormikSelect;
